class ESPError extends Error {
}
class TimeoutError extends ESPError {
}
export { ESPError, TimeoutError };
